import React, { PropsWithChildren, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons/faAngleRight";

type Props = {
  title: string;
}
const ToggleItem: React.FC<PropsWithChildren<Props>> = ({ children, title }) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className={"w-full"}>
    <div className={"flex cursor-pointer"} onClick={() => setIsOpen(!isOpen)}>
      <div className={"w-[14px] mr-1"}>
        <FontAwesomeIcon className={"text-blue-500"} icon={isOpen ? faAngleDown : faAngleRight} />
      </div>
      <div className={"w-full"}>
        <div className={"text-blue-500 w-full"}>{title}</div>
        {isOpen &&
          <div className={"py-2"}>
            {children}
          </div>
        }
      </div>
    </div>
  </div>
    ;
};

export const Faq: React.FC = () => {
  return <div id={"Faq"}>
    <h2>
      FAQ
    </h2>
    <div className={"flex flex-col gap-3"}>
      <ToggleItem title={"Где отображается отгруженный контнент на площадках?"}>
        Найти альбомы, треки и видео можно в карточках музыкантов и в поиске по музыкальным разделам
      </ToggleItem>
      <ToggleItem title={"Учитываются ли в статистике прослушивания пользовательских копий контента"}>
        Да, при условии достаточной похожести на оригинал в релизе.
      </ToggleItem>
      <ToggleItem
        title={"В какой момент начинается монетизация пользовательских копий? Перейдут ли просмотры и прослушивания с ранее загруженного контента?"}>
        После отгрузки официального релиза и его обработки площадкой
        прослушивания пользовательских копий с высокой степенью похожести начинают учитываться в пользу официального
        релиза. До этого момента статистика прослушиваний пользовательских копий не собирается.
      </ToggleItem>
      <ToggleItem title={"Сколько времени занимает обработка нового альбома или апдейта?"}>
        Штатный срок обработки продуктов составляет полные <b>рабочие сутки на нашей стороне</b> с момента поступления к
        нам. После этого каждая площадка обрабатывает и индексирует продукты в разделы витрины в рамках своих сроков,
        которые вы можете запросить у интересующих вас площадок. Поставка может быть обработана и быстрее, сроки
        напрямую зависят от уровня нагрузки на системы, очереди доставки и обработки как на нашей стороне, так и на
        стороне площадок.
      </ToggleItem>
      <ToggleItem title={"Куда пропал черновик?"}>
        Черновик должен быть опубликован в течение месяца с даты создания. Спустя месяц после создания содержимое
        неопубликованного Черновика может быть удалено.
      </ToggleItem>
      <ToggleItem title={"Необходимо срочно доставить приоритетный релиз, что делать?"}>
        В случае потребности публикации/редактирования приоритетного релиза в сжатые сроки (менее суток) необходимо
        уведомить редакцию, указав ссылку на альбом, если она уже известна, UPC релиза, название альбома и исполнителя.
      </ToggleItem>
      <ToggleItem title={"На странице альбома не отображаются правки, внесенные в релиз через автоматический фид DDEX"}>
        Удостоверьтесь, что в Личном кабинете отсутствует Черновик проблемного альбома. Создание Черновика автоматически
        "блокирует" ветку продукта, это значит, что последующие апдейты (в т.ч. поступившие через автоматический фид
        DDEX, если вы его используете) будут обработаны только после публикации или удаления созданного Черновика.
      </ToggleItem>
      <ToggleItem
        title={"Как смэтчить статистику бек-каталога и сделать так, чтобы у пользователей работали ранее добавленные альбомы?"}>
        Объединение плейлистов происходит автоматически раз в сутки при сооблюденнии следующих условий:
        <ul className={"list-disc"}>
          <li>
            Коды UPC полностью идентичны
          </li>
          <li>
            Новый альбом уже отгружен, а лицения со всех остальных альбомов отозвана
          </li>
        </ul>
      </ToggleItem>
      <ToggleItem title={"Как сохранить место в чарте при переносе альбома от другого правообладателя?"}>
        Необходимо отгрузить трек с идентичными метаданными: строго с таким же
        кодом ISRC, идентичной фонограммой, исполнителем, названием и подзаголовком при его наличии
      </ToggleItem>
      <ToggleItem title={"В альбоме два разных трека звучат одинаково, апдейты не помогают"}>
        Скорее всего, при первичной отгрузке или апдейте двум разным трекам были присвоены одинаковые служебные коды
        (ISRC или External ID) или идентичные фонограммы, что привело к слиянию двух треков. Для исправления ситуации
        нужно изъять задействованные треки и загрузить их заново с корректными кодами и фонограммами.
      </ToggleItem>
      <ToggleItem title={"С какого момента прослушивание трека считается как финансовое событие?"}>
        С 31-й секунды. Актуально и для аудио-, и для видеоконтента
      </ToggleItem>
      <ToggleItem title={"Монетизируются ли прослушивания трека в VK клипах и Историях?"}>
        Прослушивание трека внутри истории или клипа — это нефинансовое событие, которое не отобразится в отчётности.
      </ToggleItem>
      <ToggleItem title={"Не удалется получить единую ссылку на альбом, что делать?"}>
        Убедитесь, что у всех треков альбома наступила дата релиза. Если дата релиза всех треков уже наступила и прошло
        более суток с момента публикации альбома, обратитесь в редакцию, приложив ссылку на проблемный альбом в Личном
        кабинете.
      </ToggleItem>
      <ToggleItem title={"Можно ли добавить трек в каталог VK клипов до даты релиза трека?"}>
        VK Клипы и Истории являются дочерней моделью Сервисов "Стримы" и "Подписка".<br />
        Добавление трека в дочернюю подкатегорию, минуя родительскую, технически невозможно.
      </ToggleItem>
      <ToggleItem title={"Почему ТОП-100 в разделе Статистики не совпадает с Чартом треков на площадках?"}>
        В раздел статистики попадают все прослушивания свыше 30 секунд без какой-либо фильтрации. Для формирования Чарта
        треков используются разнообразные фильтры, валидирующие прослушивания. По этой причине список и расположение
        треков в Статистике может не совпадать с Чартом треков на площадках.
      </ToggleItem>
      <ToggleItem title={"Почему не удаётся перенести релиз в корректную карточку?"}>
        Убедитесь, пожалуйста, что адрес необходимой карточки указан для всех задействованных треков в разделе
        "Трек-лист".
        <br /><br />
        Перенос релиза может быть недоступен, если в него уже были внесены изменения Командой ВКонтакте. В такой
        ситуации
        для переноса релиза можно отправить запрос по адресу <a
        href={"mailto:vkmusicsupport@corp.vk.com"}>vkmusicsupport@corp.vk.com</a> или по ссылке
        {" "}<a href={"https://vk.com/support?act=new_amt"} target={"_blank"} rel={"noreferrer"}>https://vk.com/support?act=new_amt</a>
      </ToggleItem>
    </div>
  </div>;
};
